'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { Button } from '@src/components/Button/Button';
import { Container } from '@src/components/Container/Container';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import type { TopNavV6SubNavItem, TopNavV6ThirdLevelMenu, TopNavV6ThirdLevelMenuItem } from '@src/components/TopNavV6/TopNavV6Props';
import { TopNavV6Tile } from '@src/components/TopNavV6/TopNavV6Tile';
import { cn } from '@src/utils/tailwind';
interface TopNavV6DesktopThirdLevelMenuProps {
  menu: TopNavV6ThirdLevelMenu;
  subNavItem: TopNavV6SubNavItem;
  isVisible: boolean;
  onMouseLeave?: () => void;
}
const MenuItem = t0 => {
  const $ = _c(22);
  const {
    item
  } = t0;
  const isShopAll = item.isShopAll;
  const t1 = !isShopAll;
  const t2 = !isShopAll;
  let t3;
  if ($[0] !== isShopAll || $[1] !== t1 || $[2] !== t2) {
    t3 = cn("font-sans text-body-sm leading-5 transition-colors group-hover:underline", {
      "text-bodi-gray-butters group-hover:text-bodi-white": t1,
      "text-bodi-accent-bright-500": isShopAll,
      "group-hover:decoration-bodi-white": t2,
      "group-hover:decoration-bodi-accent-bright-500": isShopAll
    });
    $[0] = isShopAll;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== item.title || $[5] !== t3) {
    t4 = <span className={t3}>{item.title}</span>;
    $[4] = item.title;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== item.badge) {
    t5 = item.badge && <div className="flex items-center gap-1 text-body-sm leading-5"><span className="font-sans font-normal text-bodi-gray-butters">-</span><span className="text-center font-sans font-medium text-bodi-accent-bright-500">{item.badge}</span></div>;
    $[7] = item.badge;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex items-center gap-1">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const content = t6;
  if (item.href) {
    let t7;
    if ($[12] !== content || $[13] !== item.href || $[14] !== item.onClick) {
      t7 = <LocalizedLink href={item.href} onClick={item.onClick} className="group flex items-center rounded-md transition-colors">{content}</LocalizedLink>;
      $[12] = content;
      $[13] = item.href;
      $[14] = item.onClick;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    return t7;
  }
  let t7;
  if ($[16] !== item) {
    t7 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        item.onClick?.();
      }
    };
    $[16] = item;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== content || $[19] !== item.onClick || $[20] !== t7) {
    t8 = <div className="group flex items-center rounded-md transition-colors" onClick={item.onClick} onKeyDown={t7} role="button" tabIndex={0}>{content}</div>;
    $[18] = content;
    $[19] = item.onClick;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export const TopNavV6DesktopThirdLevelMenu = t0 => {
  const $ = _c(37);
  const {
    menu,
    subNavItem,
    isVisible,
    onMouseLeave
  } = t0;
  const [shouldShow, setShouldShow] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isVisible) {
    t1 = () => {
      if (isVisible) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setShouldShow(true);
          });
        });
      } else {
        setShouldShow(false);
      }
    };
    t2 = [isVisible];
    $[0] = isVisible;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[3] !== menu.columns || $[4] !== menu.violatorGridSize || $[5] !== menu.violators || $[6] !== onMouseLeave || $[7] !== shouldShow) {
    const violators = (menu.violators ?? []).filter(_temp);
    const violatorGridSize = menu.violatorGridSize ?? 1;
    const effectiveViolatorGridSize = violators.length === 0 || violatorGridSize === 0 ? 0 : violatorGridSize;
    const contentGridCols = 4 - effectiveViolatorGridSize;
    t6 = onMouseLeave;
    const t9 = !shouldShow;
    if ($[15] !== shouldShow || $[16] !== t9) {
      t7 = cn("absolute top-full left-0 z-30 w-full border-b border-bodi-gray-dark bg-bodi-black-text py-8 transition-opacity duration-300 ease-in-out", {
        "opacity-0 invisible pointer-events-none": t9,
        "opacity-100 visible": shouldShow
      });
      $[15] = shouldShow;
      $[16] = t9;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = {
        backgroundImage: "linear-gradient(90deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%), linear-gradient(90deg, rgba(22, 24, 25, 1) 0%, rgba(22, 24, 25, 1) 100%)"
      };
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    T0 = Container;
    t3 = "grid grid-cols-4 gap-8";
    if ($[19] !== contentGridCols || $[20] !== menu.columns) {
      t4 = menu.columns.length > 0 && <div className={cn("grid gap-8", {
        "col-span-1 grid-cols-1": contentGridCols === 1,
        "col-span-2 grid-cols-2": contentGridCols === 2,
        "col-span-3 grid-cols-3": contentGridCols === 3,
        "col-span-4 grid-cols-4": contentGridCols === 4
      })}>{menu.columns.map(_temp2)}</div>;
      $[19] = contentGridCols;
      $[20] = menu.columns;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    t5 = violators.length > 0 && effectiveViolatorGridSize > 0 && <div className={cn("grid gap-8", {
      "col-span-1 grid-cols-1": effectiveViolatorGridSize === 1,
      "col-span-2 grid-cols-2": effectiveViolatorGridSize === 2,
      "col-span-3 grid-cols-3": effectiveViolatorGridSize === 3,
      "col-span-4 grid-cols-4": effectiveViolatorGridSize === 4
    })}>{violators.map(_temp3)}</div>;
    $[3] = menu.columns;
    $[4] = menu.violatorGridSize;
    $[5] = menu.violators;
    $[6] = onMouseLeave;
    $[7] = shouldShow;
    $[8] = T0;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    T0 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
    t6 = $[12];
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t9 = <div className={t3}>{t4}{t5}</div>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== subNavItem.ctaButton) {
    t10 = subNavItem.ctaButton?.title && subNavItem.ctaButton.title !== "" && <div className="mt-8 flex justify-start">{subNavItem.ctaButton.href ? <LocalizedLink href={subNavItem.ctaButton.href} onClick={subNavItem.ctaButton.onClick}><Button size="medium" variant="primary" contentClassName="tracking-normal">{subNavItem.ctaButton.title}</Button></LocalizedLink> : <Button size="medium" variant="primary" contentClassName="tracking-normal" onClick={subNavItem.ctaButton.onClick}>{subNavItem.ctaButton.title}</Button>}</div>;
    $[26] = subNavItem.ctaButton;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== T0 || $[29] !== t10 || $[30] !== t9) {
    t11 = <T0>{t9}{t10}</T0>;
    $[28] = T0;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t6 || $[34] !== t7 || $[35] !== t8) {
    t12 = <div onMouseLeave={t6} className={t7} style={t8}>{t11}</div>;
    $[32] = t11;
    $[33] = t6;
    $[34] = t7;
    $[35] = t8;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
};
function _temp(violator) {
  return violator.isVisible !== false;
}
function _temp2(column, columnIndex) {
  return <div key={`column-${columnIndex}`} className="flex flex-col">{column.title && <div className="mb-2">{column.href ? <LocalizedLink href={column.href}><h3 className="font-sans text-body-base leading-6 font-medium text-white hover:underline">{column.title}</h3></LocalizedLink> : <h3 className="font-sans text-body-base leading-6 font-medium text-white">{column.title}</h3>}</div>}{column.items && column.items.length > 0 && <div className="flex flex-col gap-1">{column.items.map((item, itemIndex) => <MenuItem key={`item-${columnIndex}-${itemIndex}`} item={item} />)}</div>}</div>;
}
function _temp3(violator_0, i) {
  return <div key={`violator-${i}`} className="flex flex-col"><TopNavV6Tile tile={violator_0} /></div>;
}